import styled from 'styled-components'
import { theme } from './../../common'

export const StyledWrapper = styled.div`
    background-color: ${theme.grey};
`
export const StyledMenuList = styled.ul`
    list-style-type: none;
    padding: 0px;
    a {
        color: ${theme.white};
    }
    li{
        padding-left: 15px;
        font-size: 1.5em;
        font-weight: lighter;
        @media screen and (max-width: 1200px) {
            font-size: 1em;
        }
        &.title {
            padding: 0px;
            font-weight: bold;
        }
    }
`
export const StyledMenuListItem = styled.li`
    color: ${theme.white};
    &.phone-container {
        display: flex;
        padding: 0px;
        .phone {
            font-size: 1.3em;
        }
        .ddd {
            font-size: .8em;
            margin-top: 4px;
            margin-right: 4px;
        }
        .phone, .ddd {
            font-weight: bold;
        }
    }
`
export const StyledBackground = styled.div`
    background-color: ${theme.primary};
    border-radius: 0px 0px 10px 10px;
    padding: 25% 20%;
    max-height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`
export const StyledSocialContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 110px;
    width: 100%;

`
export const StyledSocial = styled.img``
export const StyledLogo = styled.img`
    margin-top: 25%;
    width: 100%;
    max-width: 260px;
`
export const StyledCopyright = styled.div`
    background-color: #464646;
    display: flex;
    flex-direction: column;
    font-size: 1em;
    color: ${theme.white};
    font-weight: lighter;
    justify-content: center;
    align-items: center;
    padding: 1% 0px;
    p { margin: 0px; }
`